module.exports = __webpack_public_path__ + "img/25.04c28940.jpg";